import React, { useState, useEffect } from 'react'

export const AutoContainer = (props) => {
  const { percent, children } = props;
  const [containerHeight, setContainerHeight] = useState(window.innerHeight);
  useEffect(() => {
    updateWidthAndHeight();
    window.addEventListener("resize", updateWidthAndHeight);
    return () => window.removeEventListener("resize", updateWidthAndHeight);
  }, []);
  const updateWidthAndHeight = () => {
    if (percent == null) {
      setContainerHeight('auto');
    }
    else {
      setContainerHeight(window.innerHeight * percent ?? 0.1);
    }
  };
  return (
    <div style={{ height: containerHeight, overflowX: 'hidden', overflowY: 'scroll' }}>
      {children}
    </div>
  )
}
